module.exports = __webpack_public_path__ + "static/media/discoverability.63eea6e3.svg";